// 按页面划分
export default {
    // 公共页面
    common: {
        title: "Дата Молл",
        pull_refresh: 'Потяните вниз, чтобы обновить',
        release_refresh: 'Отпустите, чтобы обновить',
        refresh_loading: 'Загрузка…',
        footer_text: 'Услуги предоставляются компанией Ucloudlink (NASDAQ: UCL)'
    },
    home: {
        input_placeholder: 'Поиск страны/региона',
        my_flow: 'Мои данные',
        charge_code: 'Код ваучера',
        coupons:'Купоны',
        local_package: 'Локальные данные',
        more: 'Более',
        popular_destination: 'Страна/регион',
        buy_now: 'Купить сейчас',
        package_useing: 'Активный',
        unused: 'Неактивный',
        download_app: 'Скачать приложение',
        enter_the_mall_list: 'Перейти в торговый центр',
        no_data: 'Нет данных пока',
        no_data_available: 'Данные отсутствуют.',
        copy_success: 'Копировать успешно',
        copy_fail: 'Не удалось скопировать',
        meritsTitle: 'Какие преимущества?',
        merits1: 'Без SIM-карты & Без ежемесячных платежей',
        merits2: 'Интегрировано с топ-2-3 операторами для автоматического переключения сети',
        go_buy: 'Перейти, чтобы купить',
        instant_savings: 'Экономия',
        expires_in: 'Истекает через',
        download_app_tips: "Скачайте приложение для больше предложений и впечатлений"
    },
    packages: {
        sub_title: {
            us: 'За исключением Гуама, Сайпана',
            it: 'Включая Ватикан, Сан-Марино.',
            va: 'Включая Италию, Сан-Марино',
            sm: 'Включая Италию, Ватикан.',
            ma: 'Включая Западную Сахару',
            eh: 'Включая Марокко',
            ch: 'Включая Лихтенштейн',
            li: 'Включая Швейцарию',
            fr: 'Включая Монако',
            mc: 'Включая Францию',
            fi: 'Включая Аландские острова',
            ax: 'Включая Финляндию',
            gu: 'Включая Северные Марианские острова.',
            mp: 'Включая Гуам'
        },
        unlimited_packages: 'Безлимитный пакет данных',
        normal_packages: 'Обычный пакет данных',
        multi_region_packages: 'Мультирегиональный',
        regional_data: 'Региональные данные',
        high_speed_text: 'высокоскоростные данные',
        infiniteFlow: 'Неограниченные данные',
        unLimitData: 'Безлимитный',
        high_speed_text_year: 'высокая скорость/м.п.',
        package_list: 'Список пакетов',
        special_offer: 'Скидки',
        first_month: '1 Месяц',
        periodUnit: {
            day: 'день(а)',
            month: 'месяц',
            hour: 'часы)',
            year: 'год',
        },
        periodUnits: {
            day: 'день(а)',
            month: 'месяцы',
            hour: 'часы)',
            year: 'годы',
        },
        periodUnitSimp: {
            day: 'д',
            month: 'для',
            hour: 'час',
            year: 'тот'
        },
        periodUnitMonthly:'Ежемесячный',
        periodUnitsSimp: {
            day: 'д',
            month: 'для',
            hour: 'час',
            year: 'тот'
        },
        unlimited_good_name: {
            day: 'Дневной пропуск',
            month: 'Месячный абонемент',
            year: 'Годовой абонемент'
        },
        continuousMonth: "Непрерывные месяцы",
        continuousDay: "Непрерывные дни",
        continuousYear: "Непрерывные годы",

        day_invalid: 'Срок действия истекает в текущий день',
        month_invalid: 'Срок действия истекает в текущем месяце',
        immediate_valid: 'Вступает в силу немедленно',
        tomorrow_day_valid: 'Действует со следующего дня',
        tomorrow_month_valid: 'Действует со следующего месяца',

        // detail page
        detail: {
            cell_flow: 'Данные',
            cell_period: 'Срок действия',
            buy_quantity: 'Количество',
            use_area: 'Покрытие',
            use_intro: 'Условия и положения',
            buy_btn: 'Заказ',
            pay: 'Оплатить',
            buy_tips: 'У вас пакет %@packageName в использовании. Хотите купить этот пакет?',
            haveOrderTips: "Создан заказ с ожиданием оплаты. Нажмите Подтвердить для перехода на Мою страницу данных！"
        },

        // confirm page
        confirm: {
            title: 'Подтверждение заказа',
            real_pay_amount: 'Оплаченная сумма',
            online_payment: 'Онлайн оплата',
            create_order_error: 'Установка не удалась'
        }
    },
    pay: {
        // result page
        result: {
            loading_order_status: 'Получение статуса заказа…',
            buy_success: 'Заказ завершен',
            buy_pending: 'Ожидает подтверждения',
            buy_pending_tip: 'Платеж в процессе... Если платеж не был переведен в течение 10 минут, свяжитесь с нами для поддержки.',
            get_payment_info_fail: 'Не удалось получить информацию о платеже',
            cell_package: 'Упаковка',
            cell_buy_amount: 'Итого',
            cell_real_amount: 'Оплаченная сумма',
            go_to_order_btn: 'Перейти в Мой пакет',
            back_home: 'Вернуться домой',
            back_mall: 'Вернуться в торговый центр',
            ordersn_empty: 'Серийный номер заказа не может быть пустым.',
            order_search_error: 'Неожиданная ошибка',
            goodsName: 'Название продукта'
        },

        //fail page
        fail: {
            payment_fail: 'Платеж не выполнен',
            back_home: 'Вернуться домой'
        }
    },
    CountryGroup: {
        title: "Страна/регион",
        placeholder: "Поиск страны или региона",
        clear: "Прозрачный",
        history: "История поиска"
    },
    PromotionCode: {
        verification: {
            title: 'Код ваучера',
            minititle: 'Код ваучера',
            input: 'Пожалуйста, введите код пополнения',
            explain: 'Советы: нажмите кнопку сканирования в правом верхнем углу, чтобы отсканировать QR-код карты ваучера, или вручную введите код ваучера (с учетом регистра), если он не работает.',
            submit: 'Представлять на рассмотрение',
            exchange: 'Выкупать',
            cancel: 'Отмена',
            Inquiry: "Вы уверены, что обменяетесь?",
            ErrorCode: 'Ошибка кода пополнения счета',
        },
        recharge_success: {
            package: 'Упаковка',
            content: 'Успешно погашено',
            back: 'Вернуться в торговый центр',
            view_packets: 'Перейти в Мой пакет'
        }
    },
    order: {
        state: {
            inUse: 'Активировано',
            isFirst: 'Приоритет',
            toFirst: 'Установить приоритет',
            inactive: 'Деактивирован'
        },
        periodUnits: {
            minute: 'минута(ы)',
            hour: 'часы)',
            day: 'день(а)',
            month: 'месяц(ы)',
        },
        useIntro: {
            tip1: 'Пакет безлимитных данных имеет более высокий приоритет, чем пакет объемных данных;',
            tip2: 'Приоритет использования будет основываться на дате покупки пакета того же типа, т. е. пакет с самой ранней датой покупки будет использован первым, в то время как приоритет пакетов для одного региона выше, чем у регионального пакета;',
            tip3: 'Вы также можете вручную настроить приоритет использования пакетов одного типа.'
        },
        myFlow: 'Мои данные',
        remainingFlow: 'Данные остались',
        remainingTime: 'Действует слева',
        remainingHighFlow: 'Остаток скорост.',
        validPeriod: 'Срок действия',
        noneFlow: 'Нет пакета данных',
        noneFlowTip: 'Пожалуйста, приобретите пакет данных и наслаждайтесь высококачественной сетью.',
        buyPackFlow: 'Купить пакеты',
        checkInvalidFlow: 'Проверьте пакет данных с истекшим сроком действия',
        orderList: {
            "title": "мои заказы",
            "amount_paid": "Общий",
            "device": "Принадлежащее устройство",
            "order_details": "Детали заказа",
            "total_amont": "Итого",
            "orderSN": "Номер заказа.",
            "createTime": "Время создания",
            "cancelTime": "Время закрытия",
            "payTime": "Время заказа",
            "unsubTime": "Время отмены",
            "payMethod": "Способ оплаты",
            "thirdSN": "Номер транзакции.",
            "delete": "Удалить",
            "cancel": "Отменить заказ",
            "unsub": "Возвращать деньги",
            "goto_cancel": "Вы хотите отменить заказ?",
            "goto_unsubscribe": "Хотите отписаться от заказа?",
            "delete_Tips": "Заказ не может быть возобновлен после удаления, поэтому ваши проблемы послепродажного обслуживания не могут быть решены.Вы уверены, что удалите его?",
            "status_success": "Завершенный",
            "status_pending": "Неоплачиваемый",
            "status_cancel": "Закрыто",
            "status_unsub": "Отменено",
            "payMethod_stripe": "Кредитная карта"
          },
    },
    registerlogin: { 
        create_account_tip:"Создайте учетную запись, начните эксклюзивный опыт",
        select_country_tip:"Устройство Использование страны/региона",
        email_name: "Почта",
        phone_name: "Телефон",
        email_address: "Адрес электронной почты",
        password: "пароль",
        country: "страна",
        select_country: "Выберите страну",
        cancel: "Отмена",
        confirm: "Конечно",
        please_enter:"Пожалуйста, введите 6-20 символов (комбинация букв, чисел или символов)",
        select_country_tips: "Выбор страны предназначен для просмотра местных пакетов. Это не может быть изменено после регистрации. Подтвердите!",
        global_roaming: "Международный код домена",
        phone_number: "номер телефона",
        agree: "соглашаться",
        user_agreement: "Пользовательское соглашение",
        and: "и",
        privacy_policy: "политика конфиденциальности",
        register_login: "Зарегистрируйтесь или войдите в систему",
        login_error: "Количество логин слишком часто, попробуйте еще раз позже!",
        register_error: "Количество регистраций слишком часто, попробуйте еще раз!",
        forgot_pwd: "Забудьте пароль",
        app_tips: "Войдите в приложение с этой учетной записью после загрузки ее для доступа к большему количеству функций.",
        download_app: "Перейти, чтобы скачать приложение",
        rememberPwd: "Помните пароль",
        third_login: "Продолжить с",
        agreement_tips: "Пожалуйста, установите флажок «Пользовательское соглашение» и «Политика конфиденциальности».",
        selectCountry_tips: "Обратите внимание, что зарегистрированная страна напрямую влияет на следующие способы оплаты и валюты, пожалуйста, выберите в соответствии с вашими потребностями.",
        login_error_cancel: "Пользователь отменил вход",
        login_error_auth: "Разрешите всплывающие окна в настройках браузера",
        device_tips: "Устройство ожидает активации. Обработка в течение 24 ч."
      },
      forgotPwd: {
        forgot_pwd: "Забудьте пароль",
        email_address: "Адрес электронной почты",
        next: "Следующий",
        email_has_been_sent: "Мы отправили электронное письмо по %@email. Пожалуйста, нажмите на ссылку и перейдите по шагам, чтобы получить свой пароль.",
        have_retrieved_it: "Я нашел это",
        unable_to_receive_email: "Не можете получить электронное письмо? Пожалуйста, проверьте, есть ли электронные письма от по %@email под вашим спамом и удаленной почтовой каталога",
        or: "или",
        resend: "Приезжать",
        global_roaming: "Международный код домена",
        phone_number: "номер телефона",
        verification_code_has_been_sent: "Мы отправили код проверки в:",
        verification_code: "Проверочный код",
        no_verification_code_received: "Не получили код проверки?",
        please_enter:"Пожалуйста, введите 6-20 символов (комбинация букв, чисел или символов)",
        reset_password: "Сбросить пароль",
        reset_successful: "Сбросить успешно"
      },
      coupons: {
        coupons_name: "Купоны",
        no_coupons: "Пока нет купонов",
        no_data: "Нет данных пока",
        applicable_to_the_following: "Купоны подходят для следующего пакета данных"
      },
      digital: {
        title: "Устройство Sn",
        purchased: "Мои покупки",
        viewAll: "Более",
        skinStore: "Магазин продукта",
        completed: "Куплен",
        goBuy: "Купить",
        order: {
            title: "Приобретенные заказы"
        },
        detail: {
            describe: "Описание"
        }
    },
    viewPL: {
        other: 'другое'
      },
    invalidFlow: {
        stateName: 'Статус',
        state: {
            NOT_ACTIVATED: "Деактивирован",
            IN_USING: "Доступный",
            USE_END: "Измученный",
            EXPIRE: "Истекший",
            TRANSFER: "Передача",
            UNSUBSCRIBE: "Отмена",
            VALID: "Действительный",
            INVALID: "Неверный",
            EXCHANGE_POINTS: "Обменять баллы"
        },
        noneFlow: 'Нет пакета данных с истекшим сроком действия',
        pageName: 'Пакет данных с истекшим сроком действия'
    },
    flowDetail: {
        title: 'Детали данных',
        flow: 'Данные',
        validTime: 'Детали данных',
        invalidTime: 'Действительно до',
        coverage: 'Покрытие',
        useIntro: 'Условия и положения',
        purchaseTime: 'Куплено в',
        subtotal: 'Итого',
        status: 'Статус',
        cancel: 'Отмена',
        buyAgain: 'Купите это снова',
        validity: 'Срок действия',
        tip: 'Уведомление',
        cancelTip: 'Вы уверены, что хотите вернуть деньги за этот пакет?',
        dataLeft: 'Данные остались'
    },
    netError: {
        try_again: 'Попробуйте еще раз',
        net_error: 'Нет сети',
        try_again_desc: 'Пожалуйста, проверьте настройки сети и повторите попытку.'
    },
    loadFail: {
        try_again: 'Попробуйте еще раз',
        load_fail: 'Загрузка не удалась',
        load_fail_desc: 'Не удалось загрузить данные, попробуйте еще раз',
        IMEI_Not_Exist: 'IMEI не существует. Попробуйте войти с правого входа.',
        Project_Not_Exist: 'Возникает ошибка. Пожалуйста, свяжитесь со службой поддержки клиентов.(01)',
        commonError: 'Возникает ошибка. Пожалуйста, свяжитесь со службой поддержки клиентов.',
    },
    settlement_Easy_and_convenient:"Легко и удобно",
    settlement_Great_deal:"Отличная сделка",
    settlement_Safe_and_secure:"Безопасно и безопасно",
    settlement_Autopay_service_regulation:"Автопейное регулирование обслуживания",
    settlement_Read:"Читать",
    settlement_No_coupon:"Нет доступного купона",
    settlement_Subtotal:"Подтотальный",
    settlement_Coupon:"Купон",
    settlement_TOTAL:"Общий",
    settlement_promotion_tip:"Рекламное предложение не может быть использовано в сочетании с любыми купонами",
    settlement_coupon_tip:"Купон не может быть использован в сочетании с любыми другими рекламными предложениями",
    member_myFlow_noList:"Нет данных",
    detail_se_content:"Безопасный, простой и удобный способ. Вы можете отказаться от подписки в любое время",
    Enter_Promo_code:"Промо -код",
    Enter_Promo_Coupon:"Купоны",
    settlement_Not_used_coupon:"Купон не используется",
    settlement_Available_coupon:"Доступный",
    settlement_Unavailable_coupon:"Недоступен",
    please_Enter_Promo_code:"Пожалуйста, введите промо -код",
    please_Select_Coupon_use:　"Пожалуйста, выберите купон, который вы хотите использовать.",
    Buy_Now:"Купить сейчас",
    Dont_Use_Any:"Не используйте",
    settlement_confirm:"Подтверждать",
    settlement_tips:"Подтверждать",
    flowDetail_unsubscribe: "Отписаться",
    flowDetail_unsubscribed: "Отписан",
    flowDetail_isCancelPackage: "Отписать этот пакет?",
    flowDetail_confirmAgreementUnsubscribe : "Вы не можете иметь большую сделку после отмены подписки. Вы уверены, что хотите отказаться от подписки?",
    flowDetail_cancel: "Отмена",
    flowDetail_cancelSuccess: "Отказаться от подписки успешно",
    packages_detail_promotion:"Повышение",
    orderTips:{
        "iDay" : "день",
        "iDays" : "дни",
        "iMonth" : "месяц",
        "iMonths" : "месяцы",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol На вашей первой покупке, Платеть %@money/%@periodSymbol позже, Вы можете отказаться от подписки в любое время",
        'Monthly_discount':"Сохраните %@saveMoney каждый %@period! Вы можете отказаться от подписки в любое время ",
        'Ordinary_monthly_package':"Безопасный, простой и удобный способ. Вы можете отказаться от подписки в любое время",
        "AlreadyPurchased":'Извините, что вы можете подписаться только на один пакет данных в данный момент. Пожалуйста, отписывайте подписку от “%@” и подпишитесь позже на любой пакет, который вы хотите после истечения срока его действия.',
        "Contract_recommendation_First":'<label>С помощью AutoPay Service, на вашей первой покупке, только платите</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Вы можете отказаться от подписки в любое время'
        +'<a class="btn">Подписаться ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>С помощью службы AutoPay только платите</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Вы можете отказаться от подписки в любое время'
        +'<a class="btn">Подписаться ></a></p>',
        "Contract_recommendation_General":"<label>С сервисом автоопэя</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Безопасный, простой и удобный способ. Вы можете отказаться от подписки в любое время'
        +'<a href="javascript:;" class="btn">Подписаться ></a></p>',
        'BanlanceDoubleCheck':'Вы уверены, что хотите заплатить с балансом?',
    },
    feedback: {
        title: "обратная связь",
        placeholder: "Пожалуйста, введите страну, которую вы хотите посетить, или любые другие вопросы, и мы будем удовлетворять ваши потребности как можно скорее!",
        submit: "Представлять на рассмотрение",
        submit_success: "Успешно отправлено",
        other_opinions: "Другие мнения",
    },
    view_country_input: 'Пожалуйста, введите свой аккаунт',
    select_package: {
        title: "Выбрать Данные",
        allPackage: 'Все Данные',
        type: "Тип",
        flow: "Данные",
        month_package: "Месячный План",
        flow_package: "Пакет Данных",
        time: "Длительность",
        period: "Цикл",
        auto_debit: "Инфо Автодебет",
        auto_subscribe: "Авто-Продление",
        detail: "Детали Данных",
        carrier: "Поддерживаемые Операторы",
        country: "Покрытые страны",
        notice: "Руководство по покупке"
    }
}